module.exports = __webpack_public_path__ + "img/camping--full.87e09ec6.jpg";